module.exports = __webpack_public_path__ + "img/SharedCharter_AppBanner-1600x600.a98827f3.jpg";